// extracted by mini-css-extract-plugin
module.exports = {"container":"purify_tncs__container--3VHDr","tnc":"purify_tncs__tnc--1svfK"};